import React, { useEffect } from "react";
import Logger from "@/utility/logger";

import "./DialogPopupFeedback.css";

function DialogPopupFeedback({ feedbackDialogOpen, setFeedbackDialogContent, feedbackDialogContent }) {
  return (
    <>
      {feedbackDialogOpen && (
        <div className="dialog-popup-feedback-form">
          <div className="dialog-popup-feedback-section">
            <div className="dialog-popup-feedback-textarea-container">
              <textarea
                onChange={(e) =>
                  setFeedbackDialogContent((prev) => ({
                    ...prev,
                    feedback: e.target.value,
                  }))
                }
                value={feedbackDialogContent.feedback}
                placeholder="Please share more details on why you are deleting this section so that we can improve the product."
                className="dialog-popup-feedback-textarea"
                rows={4}
              />
              <div className="dialog-popup-feedback-textarea-counter">{feedbackDialogContent.feedback.length}/500</div>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default DialogPopupFeedback;
